(function (window, document) {
  'use strict';

  function about(box) {
    var toggle = box.querySelector('.journalist-profile__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && window.JN && window.JN.pillFit) window.JN.pillFit(box);
    });
  }

  function copy(button) {
    button.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(button.getAttribute('data-copy-text'));
      if (button.getAttribute('data-done')) button.textContent = button.getAttribute('data-done');
    });
  }

  function more(box) {
    var button = box.querySelector('button');
    var list = box.previousElementSibling && box.previousElementSibling.classList.contains('article-card-list')
      ? box.previousElementSibling : document.querySelector('.article-card-list');
    button.addEventListener('click', function () {
      var page = Number(box.getAttribute('data-page'));
      button.disabled = true;
      fetch(box.getAttribute('data-work-more') + '?page=' + page, {credentials: 'same-origin'})
        .then(function (r) {
          return r.text().then(function (html) { return {html: html, more: r.headers.get('X-Has-More') === '1'}; });
        })
        .then(function (res) {
          list.insertAdjacentHTML('beforeend', res.html);
          if (window.JN && window.JN.pillFit) window.JN.pillFit(list);
          if (res.more) { box.setAttribute('data-page', String(page + 1)); button.disabled = false; }
          else box.remove();
        })
        .catch(function () { button.disabled = false; });
    });
  }

  function headline(button) {
    var dialog = document.getElementById('headline-dialog');
    if (!dialog) return;
    var form = dialog.querySelector('[data-headline-form]');
    var input = form.querySelector('[name=headline_tx]');
    var automatic = form.querySelector('[name=automatic]');
    var error = form.querySelector('[data-headline-error]');
    button.addEventListener('click', function () { dialog.showModal(); });
    automatic.addEventListener('change', function () {
      input.disabled = automatic.checked;
      if (!automatic.checked) input.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var body = new URLSearchParams({headline_tx: input.value, automatic: automatic.checked ? '1' : ''});
      window.JN.xsrf.fetch('/profile/headline', {method: 'POST', body: body, credentials: 'same-origin'})
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status === 'OK') {
            document.querySelectorAll('[data-headline]').forEach(function (el) { el.textContent = res.headline; });
            input.placeholder = res.headline;
            error.hidden = true;
            dialog.close();
          } else {
            error.textContent = (res.errors && res.errors[0] && res.errors[0][1]) || '';
            error.hidden = false;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-headline-edit]').forEach(headline);
    document.querySelectorAll('[data-about]').forEach(about);
    document.querySelectorAll('[data-copy-text]').forEach(copy);
    document.querySelectorAll('[data-work-more]').forEach(more);
  }

  window.JN = window.JN || {};
  window.JN.journalistProfile = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
